module.exports = __webpack_public_path__ + "files/37bdb7f8db233daef529366b5772bb3f.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/windows_dark.png
// module id = 652
// module chunks = 27